import { isSlotWithOpenWaitingList } from '../slotAvailability/slotAvailability';
import { Optional } from '../../types/types';
import {
  BookingPreference,
  SelectedBookingPreference,
} from '../bookingPreferences/bookingPreferences';
import { isSelectedBookingPreferenceWithWaitingList } from '../selectedBookingPreferences/selectedBookingPreferences';
import { TimeSlot } from '@wix/ambassador-bookings-availability-v2-time-slot/types';

export const isWaitingListFlow = ({
  selectableSlots,
  selectedBookingPreferences,
  bookingPreferences,
}: {
  selectableSlots: Optional<TimeSlot[]>;
  selectedBookingPreferences: SelectedBookingPreference[];
  bookingPreferences: BookingPreference[];
}): boolean => {
  return (
    areAllSlotsWithWaitingList(selectableSlots) ||
    isAtLeastOneSelectedPreferenceWithWaitingList(
      selectedBookingPreferences,
      bookingPreferences,
    )
  );
};

const areAllSlotsWithWaitingList = (
  selectableSlots: Optional<TimeSlot[]>,
): boolean => {
  return selectableSlots?.length
    ? selectableSlots.reduce(
        (accumulator: boolean, slotAvailability: TimeSlot) =>
          isSlotWithOpenWaitingList(slotAvailability) && accumulator,
        true,
      )
    : false;
};

const isAtLeastOneSelectedPreferenceWithWaitingList = (
  selectedBookingPreferences: SelectedBookingPreference[],
  bookingPreferences: BookingPreference[],
): boolean => {
  return selectedBookingPreferences.reduce(
    (
      accumulator: boolean,
      selectedBookingPreference: SelectedBookingPreference,
    ) =>
      isSelectedBookingPreferenceWithWaitingList(
        selectedBookingPreference,
        bookingPreferences,
      ) || accumulator,
    false,
  );
};
